var redirects = {};

redirects.do = function ($form, response) {
	if ('undefined' != typeof response.data.redirect) {
		var refresh_timeout = 1000;
		setTimeout(function () {
			window.location = response.data.redirect;
		}, refresh_timeout);
	}
}

export { redirects };
